import styled from 'styled-components';

export const StyledReservationSummary = styled.div`
  .summary {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .summary-inner-wrapper {
    display: flex;
    align-items: center;
    gap: 0.25rem;
  }
`;
